module.exports = __webpack_public_path__ + "media/assets/logo/Nome_SemLogo_SemFundo_Agrosim_branco-30cc16b3b31bd1da3b3801f8e2ddc5bf.png";